/**
 * config.ts
 *
 * Centralized configuration for the application.
 * This file contains all the environment-specific variables and constants
 * required for Azure AD authentication and SharePoint integrations.
 */

// MSAL (Microsoft Authentication Library) Configuration
export const msalConfig = {
  auth: {
    // The Client ID of the Azure Active Directory App Registration
    clientId: "7a2ae3a0-61f8-4bac-bd98-566bf3c1dda9",
    // The Tenant ID of the Azure Active Directory
    authority: "https://login.microsoftonline.com/3c90a2ff-691c-483a-8e94-fbca1b7d4edf",
  },
};

// ============================================================================
// SharePoint Log Configuration
// ============================================================================
// The unique ID for the SharePoint site where the upload logs reside.
export const sharePointLogSiteId = "22f5abbf-f461-4ccb-be6a-d947a13f828b";

// The unique ID for the SharePoint list used for tracking and logging file uploads.
export const sharePointLogListId = "b341e864-d091-472f-8d06-059de0e71c46";

// ============================================================================
// SharePoint Favorites Configuration
// ============================================================================
// The unique ID for the SharePoint site where the configuration list for User Favorites resides.
export const sharePointConfigSiteId = "22f5abbf-f461-4ccb-be6a-d947a13f828b";

// The unique ID for the SharePoint list used for saving User Favorites.
export const sharePointConfigListId = "c43a78de-3584-4a59-8ff2-8f8f6f66ea43";
